import classNames from 'classnames'
import { Children, ReactElement, ReactNode } from 'react'
import styles from './index.module.css'

interface Props {
  className?: string
  children: ReactNode
  sticky?: boolean
}

export function TabList(props: Props): ReactElement {
  return (
    <ul className={classNames(styles.tabList, props.sticky && styles['stick-to-top'], props.className)}>
      {Children.map(props.children, (child) => (
        <li className={styles.tabItem}>{child}</li>
      ))}
    </ul>
  )
}
